<template>
<div id="PieChart"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "PieChart",
  methods: {
    myPieChart() {
      const chartDom = document.getElementById('PieChart');
      const myChart = echarts.init(chartDom);
      let option;

      option = {
        title: {
          text: '科室患者分布',
          subtext: '数据统计',
          left: 'center',
          textStyle: {
            color: '#8B4513',
            fontSize: 18,
            fontWeight: 'bold'
          },
          subtextStyle: {
            color: '#A0522D',
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#8B4513'
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 1048, name: '中医内科' },
              { value: 735, name: '针灸推拿科' },
              { value: 580, name: '妇科' },
              { value: 484, name: '儿科' },
              { value: 300, name: '皮肤科' },
              { value: 200, name: '治未病科' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };
      myChart.setOption(option);
    }
  },
  mounted() {
    this.myPieChart()
  }
}
</script>

<style scoped>
#PieChart{
  height: 100%;
  width: 100%;
  min-height: 350px;
  aspect-ratio: 16/9;
  background: white;
  border-radius: 3px;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 50%);
}
</style>